export const thunkResponseChecker = async (
  fn: () => Promise<any>,
  rejectWithValue: (value: unknown) => any,
  isData = true
) => {
  const response = await fn();

  const responseData = JSON.parse(response.data);

  if (responseData.success) {
    if (isData && responseData.data) {
      return responseData.data;
    } else {
      return;
    }
  }

  return rejectWithValue(responseData.errors);
};
